import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useAppSelector } from "../../Redux/hooks";

const CloudUrlSetter = () => {
  let [, setSearchParams] = useSearchParams();
  const { searchText, type, page } = useAppSelector((state) => state.cloud);

  useEffect(() => {
    const params = new URLSearchParams();
    if (searchText) {
      params.set("search", searchText);
    }
    if (type === "highlight") {
      params.set("page", page.toString());
    }
    if (type) {
      params.set("type", type);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, searchText, type, page]);

  return <></>;
};

export default CloudUrlSetter;
